// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"56c03c4b","770":"1be0f431"}[chunkId] + ".chunk.js";
};